import { observer } from 'mobx-react-lite'

import { StatusTag } from '@/Ship/Components/StatusTag'

/** Те, що клітинка бере з `formContext` картки власника. */
export interface CrmStatusCellFormContextLike {
    isEditable?: boolean
    values?: { status?: { title?: unknown; color?: unknown } | null; [key: string]: unknown }
}

export interface CrmStatusCellProps {
    formContext: CrmStatusCellFormContextLike
    /** Підпис поля — той самий, що в ресурсі власника */
    label: string
}

/**
 * «Статус» власника CRM у блоці картки — лише перегляд (`SPEC-008` §5.4):
 * статус ставлять створення («Новий») і переходи верифікації, а не форма.
 *
 * Малюється бейджем кольору довідника — тим самим `StatusTag`, що в колонці
 * реєстру й у шапці. Ядровий `StatusInput` тут не годиться: він шукає статус
 * серед `options` ресурсу, а в CRM статус — рядок довідника.
 *
 * Розмітка — та сама, що в Ship-шаблонів поля (`BaseViewFieldTemplate` /
 * `BaseFieldTemplate`): підпис стоїть там само, де в сусідніх полів, і e2e
 * знаходить поле за підписом тим самим локатором (`helpers/ui.formField`).
 *
 * Окремий observer: шаблон картки значень полів не читає (`SPEC-002` §4.2).
 */
export const CrmStatusCell = observer(({ formContext, label }: CrmStatusCellProps) => {
    const status = formContext.values?.status
    const color = typeof status?.color === 'string' ? status.color : undefined
    const tag =
        status && typeof status.title === 'string' ? (
            <StatusTag label={status.title} {...(color ? { color } : {})} />
        ) : (
            '—'
        )

    if (formContext.isEditable !== true) {
        return (
            <div className="form-field-view">
                <div className="field-view-label">{label}</div>
                <div className="field-view-value">{tag}</div>
            </div>
        )
    }

    return (
        <div className="form-field form-field-default">
            <label className="field-label">
                <h2 className="field-label-title">{label}</h2>
            </label>
            <div>{tag}</div>
        </div>
    )
})
